const AddHeader = () => {
  return (
    <div>
      <h3 className='text-lg font-medium leading-6 text-gray-900'>
        Add a new employer
      </h3>
      <p className='mt-1 text-sm text-gray-600'>
        You will be able to add roles for this employer after adding the
        information below
      </p>
    </div>
  );
};

export default AddHeader;
